<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Exam Live Dashboard</span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="card">
            <v-card-title class="heading">Exam Live Dashboard</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">Date</label>
                        <p class="value">{{start_date}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">Start Time</label>
                        <p class="value">{{starttime}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <label class="label">End Time</label>
                        <p class="value">{{endtime}}</p>
                    </v-col>
                    <v-col cols="12" lg="3" sm="6">
                        <!-- <v-text-field label="Remaining Time(minutes)" v-model="remtime" readonly></v-text-field> -->
                        <label class="label">Remaining Time(minutes)</label>
                        <p class="value">{{remtime}}</p>
                    </v-col>
                </v-row>
            </v-card-text>
            <template>
                <v-data-table :search="search1" item-key="srno" v-if="geolocation_config == true" :headers="newHeaders" :items="examlearnerlist" class="elevation-1 table-data">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search1" label="Search" class="pt-4"></v-text-field>
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.proctor="{ item }">
                        <v-autocomplete
                            placeholder="Select Proctor"
                            class="select mt-4"
                            :items="all_proctors"
                            item-text="proctor_name"
                            return-object
                            outlined
                            @change="assignProctor(item)"
                            dense
                            v-model="proctor_name"
                            persistent-hint
                        ></v-autocomplete>
                    </template>
                </v-data-table>
            </template>
        </v-card>
        <div class="text-center" v-if="loading4">
            <v-progress-circular v-model="loading4" :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loading4: false,
            details_id: "",
            start_date: "",
            starttime: "",
            endtime: "",
            extratime: null,
            examstatuslist: "",
            extra: "",
            status: "",
            search1: "",
            remtime:null,
            newHeaders: [
                { text: "SrNo", value: "srno" },
                { text: "Student Name", value: "grno" },
                { text: "Exam Start Time", value: "start_time" },
                { text: "Student Start Time", value: "started_at" },
                { text: "End Time", value: "end_time" },
                { text: "Student End Time", value: "exam_end_time" },
                { text: "Current Proctor", value: "proctor_name" },
                { text: "Assign Proctor", value: "proctor" },
            ],

            snackbar_msg: "",
            color: "",
            snackbar: false,
            examlearnerlist: [],
            all_proctors: [],
            proctor_name: null,
            search: "",
            geolocation_config: false,
        }),
        mounted() {
            this.proceed();
        },
        methods: {
            assignProctor(item) {
                let item_index = this.examlearnerlist.indexOf(item)
                const formData = {
                    proctor: this.proctor_name.exam_proctor_session_id,
                    les_id: item.id,
                };
                axios
                    .post("ExamLiveDashbord/assignProctorToStudent", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.reason);
                                this.examlearnerlist[item_index].proctor_name =  this.proctor_name.proctor_name
                                // this.examlearnerlist[item_index].proctor_name = this.proctor_name.proctor_name
                                // Object.assign({}, item)
                            } else {
                                this.showSnackbar("#b71c1c", res.data.reason);
                            }
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.loading4 = true;
                    });
            },

            refreshTable() {
                //alert("Reload Table")
                this.proceed();
            },

            proceed() {
                if (this.$store.getters.exam_id == null) {
                    // alert('exam_id id not passed')
                    this.$router.push({ name: "coe-live-dashbord" });
                }
                const formData = {
                    examtt: this.$store.getters.exam_id,
                };
                (this.loading4 = true),
                    axios
                        .post("ExamLiveDashbord/getlearnerProctorDetails", formData)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                if (res.data.geolocation_config == "YES") {
                                    this.geolocation_config = true;
                                } else {
                                    this.geolocation_config = false;
                                }
                                this.examlearnerlist = res.data.Exam_Details_List;
                                this.all_proctors = res.data.all_proctors;
                                this.start_date = res.data.examdate;
                                this.starttime = res.data.examstarttime;
                                this.endtime = res.data.examendtime;
                                this.remtime = res.data.remtime;
                                this.loading4 = false;
                            } else {
                                this.loading4 = false;
                                this.showSnackbar("#b71c1c", "Exam Has Not Started Yet....");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            this.loading4 = false;
                        })
                        .finally(() => {
                            var loading4 = false;
                        });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .refresh {
        font-size: 11px;
        color: green;
    }
    .ex-text {
        font-weight: 500;
        margin-bottom: 0px;
    }
    .elevation-1 /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        /* white-space: nowrap !important; */
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    .label {
        font-weight: bold;
        color: hsla(190, 99%, 30%, 1);
        font-size: 15px;
    }
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
        border-radius: 7px;
    }
    .value {
        font-size: 17px;
    }
    .inner-box {
        padding-top: 1rem;
        border: 2px solid hsla(190, 99%, 30%, 1);
        margin: 6px;
        border-radius: 7px;
    }
    .v-data-table tbody tr td {
        border: none !important;
    }
    .table-data {
        margin: 8px;
    }
    .time >>> .v-input__slot {
        width: 10rem;
    }
    .abstud {
        text-decoration: underline;
    }
    .textcolor {
        color: orange;
    }
    .eye {
        font-size: 30px;
        cursor: pointer;
    }
    .card {
        border: 1px solid hsla(190, 99%, 30%, 1) !important;
    }
    .theme--light.v-data-table thead tr th {
        color: white;
        background-color: hsla(190, 99%, 30%, 1) !important;
        font-weight: bold;
    }
    .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
    .time-btn {
        height: 2rem;
        background-color: red;
        padding: 2px;
    }
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .v-progress-circular {
        margin: 1rem;
    }
    .mytable /deep/ thead th {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white !important;
        white-space: nowrap !important;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
</style>
